import { render, staticRenderFns } from "./Piece.vue?vue&type=template&id=820d6a3e&scoped=true&"
import script from "./Piece.vue?vue&type=script&lang=js&"
export * from "./Piece.vue?vue&type=script&lang=js&"
import style0 from "./Piece.vue?vue&type=style&index=0&id=820d6a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820d6a3e",
  null
  
)

component.options.__file = "Piece.vue"
export default component.exports